// Catálogo de módulos do sistema para o RBAC granular por usuário (todos os módulos).
export const MODULOS = [
  { key: "dashboard", grupo: "Visão geral", label: "Dashboard", acoes: ["ver"] },
  { key: "analitico", grupo: "Visão geral", label: "Painel Analítico", acoes: ["ver"] },
  { key: "painel", grupo: "Assistencial", label: "Painel Assistencial (cards de cuidados)", acoes: ["ver"] },
  { key: "tv", grupo: "Assistencial", label: "Modo TV (monitor do posto)", acoes: ["ver"] },
  { key: "residentes", grupo: "Residentes", label: "Residentes (ficha cadastral)", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "prontuario", grupo: "Residentes", label: "Prontuário (registros e linha do tempo)", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "arquivos", grupo: "Residentes", label: "Arquivos e Documentos anexos do Residente", acoes: ["ver", "criar", "excluir"] },
  { key: "documentos", grupo: "Residentes", label: "Imprimir documentos / contrato (Ver = imprimir, Cadastrar = enviar por e-mail)", acoes: ["ver", "criar"] },
  { key: "relatorios", grupo: "Residentes", label: "Relatórios (residentes, ocupação, aniversariantes)", acoes: ["ver"] },
  { key: "fornecimento", grupo: "Estoque", label: "Fornecimento Familiar", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "consumo", grupo: "Estoque", label: "Consumo de Internação", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "estoque", grupo: "Estoque", label: "Estoque da Empresa", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "produtos", grupo: "Estoque", label: "Produtos", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "inventario", grupo: "Estoque", label: "Inventário", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "faturas", grupo: "Financeiro", label: "Faturas (Contas a Receber) e boletos", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "contas_pagar", grupo: "Financeiro", label: "Contas a Pagar", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "fornecedores", grupo: "Financeiro", label: "Fornecedores", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "servicos_extras", grupo: "Financeiro", label: "Serviços Extras", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "dre", grupo: "Financeiro", label: "Relatórios / DRE", acoes: ["ver"] },
  { key: "mensagens", grupo: "Comunicação", label: "Mensagens (chat interno)", acoes: ["ver"] },
  { key: "notificacoes", grupo: "Comunicação", label: "Notificações", acoes: ["ver"] },
  { key: "envios", grupo: "Comunicação", label: "Painel de Envios (boletos, WhatsApp, e-mails)", acoes: ["ver"] },
  { key: "profissionais", grupo: "Administração", label: "Profissionais", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "usuarios", grupo: "Administração", label: "Usuários e permissões", acoes: ["ver", "criar", "editar", "excluir"] },
  { key: "configuracoes", grupo: "Administração", label: "Configurações (empresa, contrato, modelos de documentos)", acoes: ["ver", "editar"] },
  { key: "integracoes", grupo: "Administração", label: "Integrações (Asaas, WhatsApp, e-mail, avisos)", acoes: ["ver", "editar"] },
];

export const ACAO_LABEL = { ver: "Ver", criar: "Cadastrar", editar: "Alterar", excluir: "Excluir" };

// Submódulos que antes eram um único módulo "financeiro" (compatibilidade com permissões antigas).
export const FIN_SUBS = ["faturas", "contas_pagar", "fornecedores", "servicos_extras", "dre"];

// Permissão de um módulo com os fallbacks de compatibilidade.
export const permDe = (perms, mod) => {
  if (!perms) return undefined;
  if (perms[mod]) return perms[mod];
  if (FIN_SUBS.includes(mod)) return perms.financeiro;
  if (mod === "prontuario") return perms.residentes;
  return undefined;
};

const full = { ver: true, criar: true, editar: true, excluir: true };
const verOnly = { ver: true, criar: false, editar: false, excluir: false };
const clinico = { painel: { ...verOnly }, tv: { ...verOnly }, residentes: { ...verOnly }, prontuario: { ...full } };

// Ponto de partida da matriz ao "personalizar" (espelha o acesso padrão do papel).
export const DEFAULT_PERMS = {
  enfermeiro: { ...clinico, arquivos: { ver: true, criar: true, editar: false, excluir: true }, fornecimento: { ...full }, consumo: { ...full }, produtos: { ...full }, mensagens: { ...verOnly } },
  cuidador: { ...clinico, fornecimento: { ...full }, consumo: { ...full }, produtos: { ...verOnly } },
  tecnico_enfermagem: { ...clinico, fornecimento: { ...full }, consumo: { ...full }, produtos: { ...verOnly } },
  medico: { ...clinico },
  nutricionista: { ...clinico },
  fisioterapeuta: { ...clinico },
};

// Perfis que suportam a matriz granular (não admin, não família).
export const PERFIS_CONFIGURAVEIS = ["enfermeiro", "cuidador", "tecnico_enfermagem", "medico", "nutricionista", "fisioterapeuta"];

export const temPermsCustom = (perms) => !!perms && typeof perms === "object" && Object.keys(perms).length > 0;
